// extracted by mini-css-extract-plugin
module.exports = {"success":"FlashMessage_success__7_ygU","error":"FlashMessage_error__1wJv9"};